export const CONSULTING_FORM_SUBMITTED_COOKIE_NAME = 'consulting_form_submitted';
export const FORM_ANCHOR = 'form';
